import { DealId } from '@upstart/harmony/lib/legos/dealTypes';
import { RehashOffer } from 'containers/RehashOffers/RehashPossibleModal/RehashPossibleModal';
import BackendService from './BackendService';

// Dummy types for now - we should be able to auto-generate this from Backend's OpenAPI docs
export type RehashResponse = {
  data:
    | RehashPossibleResponse
    | RehashNotPossibleResponse
    | RehashNotNeededResponse;
};

export type RehashPossibleResponse = {
  result: 'rehash_possible';
  offerDetails: RehashOffer;
};

export type RehashNotPossibleResponse = {
  result: 'rehash_not_possible';
  reasons: string[];
};

export type RehashNotNeededResponse = {
  result: 'rehash_not_needed';
};

export default class WorkflowFinanceApplicationService {
  static BASE_URL = '/v2/workflow/finance-application';

  static calculateRehash(dealId: DealId): Promise<RehashResponse> {
    return BackendService.get(`${this.BASE_URL}/calculate-rehash/${dealId}`);
  }

  static rehashDeal(dealId: DealId, rehashOffer: RehashOffer): Promise<void> {
    return BackendService.patch(`${this.BASE_URL}/rehash/${dealId}`, {
      body: { offerDetails: rehashOffer },
    });
  }

  static offersFound(dealId: DealId): Promise<void> {
    return BackendService.patch(`${this.BASE_URL}/offers-found/${dealId}`);
  }

  static refreshOffers(dealId: DealId): Promise<void> {
    return BackendService.put(`${this.BASE_URL}/refresh-offers/${dealId}`);
  }
}
